import {
    OverviewGroupBaseConfig,
    requestGroupBaseParams
} from '@/lib/analyticsGroup/pages/overview/base';

export const OverviewGroupConfig = {
    base: {
        config: OverviewGroupBaseConfig,
        fields: requestGroupBaseParams
    }
} as const;
